import { render, staticRenderFns } from "./mktForm.vue?vue&type=template&id=c4a52a02&"
import script from "./mktForm.vue?vue&type=script&lang=js&"
export * from "./mktForm.vue?vue&type=script&lang=js&"
import style0 from "./mktForm.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports